<template>
  <div class="w-full users-wrapper">
    <div>
      <vs-table
        :data="kamera_list">
        <template slot="header">
          <h3 class="pb-4 text-white">
            Kameralar
          </h3>

          <div class="sub-text flex w-full justify-end">
            <c-s-v-parser :updated="kameraUpdated" class="mr-2" />
            <span class="main-button blue-button" @click="showPopup = true">Kamera Ekle</span>

          </div>
        </template>
        <template slot="thead">
          <vs-th>
            İsim
          </vs-th>
          <vs-th>
            Id
          </vs-th>
          <vs-th>
            Ayarlar
          </vs-th>

        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td :data="tr.name">
              {{tr.alarm_node}}
            </vs-td>


            <vs-td :data="tr.id">
              {{tr.id}}
            </vs-td>
            <vs-td>
              <div class="flex flex-grow-1">
                <vx-tooltip text="Düzenle">
                  <div class="p-2" @click="editKamera(tr)"><i class="fa fa-edit"></i></div>
                </vx-tooltip>
                <vx-tooltip text="SMS Gönder">
                  <div class="p-2"><i class="fa fa-send"></i></div>
                </vx-tooltip>
                <vx-tooltip text="Kullanıcıyı Sil">
                  <div class="p-2" @click="alertDelete(tr.id)"><i class="fas fa-trash"></i></div>
                </vx-tooltip>
              </div>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
      <pagination
        v-model="page"
        :per-page="max"
        :records="count" @paginate="clickCallback"
      >
      </pagination >
    </div>
    <kamera-popup v-if="showPopup" :kamera="edit" :updated="kameraUpdated" :cancelled="kuleCancelled" />
  </div>
</template>

<script>
import KameraPopup from '../models/kamera/KameraPopup'
import Pagination from 'vue-pagination-2'
import CSVParser from './CSVParser'
export default {
  name: 'Kameralar',
  components: {
    KameraPopup,
    Pagination,
    CSVParser
  },
  data () {
    return {
      editActive: false,
      edit: null,
      editProp: '',
      search: '',
      allCheck: false,
      page: 1,
      count: 0,
      max: 10,
      active: 0,
      selected: [],
      showPopup: false
    }
  },
  watch: {
    page () {
      console.log('page changed')
      this.getData()
    }
  },
  computed: {
    pagecount () {
      return Math.round(this.max / this.count)
    },
    profile_placeholder () {
      return require('@/assets/images/Portrait_Placeholder.png')
    },
    kamera_list () {
      return this.$store.state.kamera_list
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    clickCallback () {
      console.log('page', this.page)
    },
    editKamera (kamera) {
      console.log('usa', kamera)
      this.edit = kamera
      this.showPopup = true
    },
    kameraUpdated (val) {
      console.log('u updated', val)
      this.showPopup = false
      this.getData()
    },
    kuleCancelled () {
      this.showPopup = false
      this.edit = null
    },
    openConfirm (text, accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Onayla',
        text,
        acceptText: 'Onayla',
        cancelText: 'Vazgeç',
        accept,
        cancel
      })
    },
    getData () {
      this.$vs.loading()
      const payload = {
        page: this.page,
        items: this.max
      }
      this.$store.dispatch('getKameraList', payload)
        .then(result => {
          this.count = result.data.count
          console.log('get kamera list success', result, this.count)
          this.$vs.loading.close()
        })
        .catch(e => {
          console.log('get kamera error', e)
          this.$vs.loading.close()
        })
    },
    alertDelete (id) {
      this.openConfirm('Bu kamerayı silmek istediğinizden emin misiniz?', () => {
        this.deleteKamera(id)
      }, () => {})
    },
    deleteKamera (id) {
      this.$store.dispatch('deleteKamera', id)
        .then(result => {
          console.log('delete kamera success', result)
          this.getData()
        })
        .catch(e => {
          console.log('delete kamera error', e)
        })
    }
  }
}
</script>

<style lang="scss">
.users-wrapper {
  max-width: 1200px;
  margin: 0 auto;
}
.con-expand-users {
  flex: 1;
  .con-btns-user {
    display: flex;
    padding: 10px;
    padding-bottom: 0;
    align-items: center;
    justify-content: space-between;
    .con-userx {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .list-icon, i {
        font-size: .9rem !important;
      }
    }
  }
}
</style>
